// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__Kg0c1","bigColWidth":"Table_bigColWidth__saxmV","biggerColWidth":"Table_biggerColWidth__3Yihm","row":"Table_row__tISm-","col":"Table_col__R5ha_"};